
import { defineComponent, PropType, ref } from "vue";
import { Customer } from "@/models/Customer";

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true
    },
    source: {
      type: Object as PropType<Customer>,
      required: true
    },
    shipTo: {
      type: Boolean,
      required: false,
      default: false
    },
    buyer: {
      type: Boolean,
      required: false,
      default: false
    },
    payer: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    validatePhone(value) {
      if (!value) {
        return true;
      }

      const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i;
      return regex.test(value);
    }
  }
});
